import React, {Component} from 'react';
import {action, observable, reaction} from 'mobx';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import Close from 'react-icons/lib/io/close';
import Slide from '@material-ui/core/Slide';
import DialogWrapper from '../../../components/dialog/Dialog';
import FormInput from '../../../components/FormHelpers/formField';
import BaseButton from '../../../components/button/BaseButton';
import {go} from '../../../utils/navigationUtility';
import './groups.scss';
import {isMobile} from '../../../utils/screenUtility';
import {actions, category, DialogTypes, events} from '../../../constants/enums';
import {customEvent} from "../../../utils/analyticsUtil";

@injectIntl
@inject('dialogStore', 'groupStore', 'manageStore')
@observer
class AddGroupDialog extends Component {
    @observable groupName = '';
    @observable groupNameError = false;

    componentDidMount() {
        reaction(
            () => this.props.groupStore.editableMode,
            action((mode) => {
                this.groupName = mode ? this.props.groupStore.activeGroup.name : '';
            })
        );
    }

    @action onChange = (currentValue, newValue = '') => {
        this.groupName = newValue;
        this.groupNameError = '';
    };

    @action handleSubmit = (e) => {
        e.preventDefault();
        const {groupStore, dialogStore, intl: {formatMessage: translate}} = this.props;
        if (groupStore.isGroupNameExists(this.groupName)) {
            this.groupNameError = translate({id: 'group.isAlreadyExists'}, {name: this.groupName});
            return;
        }
        if (groupStore.editableMode) {
            groupStore.editGroup(groupStore.activeGroupID, this.groupName);
        } else {
            this.createGroup();
        }
        customEvent(events.CustomEvent, {category: category.AddGroup});
        dialogStore.closeDialog(DialogTypes.AddGroup);
    };

    createGroup = async () => {
        const {groupStore, manageStore, dialogStore, teacherId} = this.props;
        try {
            await groupStore.addGroup(this.groupName, teacherId);
            go(`/home/group/${groupStore.activeGroupID}`);
            if (manageStore.liveStudentsLength) {
                manageStore.setStudentsInGroup(groupStore.activeGroup.students || []);
                groupStore.setShowSkip(true);
                dialogStore.openDialog(DialogTypes.GroupStudents);
            }
        } catch (err) {
            console.warn(err.message);
        }
    };

    onClose = () => {
        this.props.dialogStore.closeDialog(DialogTypes.AddGroup);
    };

    @action handleExited = () => {
        this.groupName = '';
        this.groupNameError = '';
        this.props.groupStore.setEditableMode(false);
    };

    render() {
        const {dialogStore, groupStore, intl: {formatMessage: translate}} = this.props;
        const translateMode = groupStore.editableMode ? 'editGroup' : 'addGroup';
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            TransitionProps: {direction: 'up'},
            classes: {root: 'group-modal-root', paper: 'paper'},
            open: dialogStore.getDialogState(DialogTypes.AddGroup),
            onExited: this.handleExited,
            onClose: this.onClose
        };

        return (
            <DialogWrapper {...dialogProps}>
                <div className="group-modal">
                    <button className="group-modal-close" onClick={() => dialogStore.closeDialog(DialogTypes.AddGroup)}>
                        <Close />
                    </button>
                    <div className="modal-page-name"><FormattedMessage id="selectStudent.heading" /></div>
                    <h3><FormattedMessage id={`${translateMode}.title`} /></h3>
                    <p><FormattedMessage id={`${translateMode}.description`} /></p>
                    <form onSubmit={this.handleSubmit}>
                        <FormInput
                            name="name"
                            type="text"
                            inputPlaceholder={translate({id: `${translateMode}.placeholder.name`})}
                            onChange={this.onChange}
                            value={this.groupName}
                        />
                        {this.groupNameError && <div className="a-form-error">{this.groupNameError}</div>}
                        <BaseButton
                            className="group-moda-btn"
                            type="submit"
                            label={translate({id: `${translateMode}.add`})}
                            disabled={this.groupName === ''}
                        />
                    </form>
                </div>
            </DialogWrapper>
        );
    }
}

export default AddGroupDialog;
